import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import {
    FaLock,
    FaMobileAlt,
    FaEye,
    FaEyeSlash,
    FaArrowLeft,
} from "react-icons/fa";
import { FiLoader } from "react-icons/fi";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../../../config";

function StaffLogin() {
    const [mobileno, setMobileno] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);

    const navigate = useNavigate();

    const handleStaffLogin = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axios.post(
                `${config.apiUrl}/api/swalook/centralized/login/`,
                { mobileno, password }
            );

            const resData = response.data;

            if (resData?.error?.message === "login successful!") {
                const {
                    token,
                    type,
                    user,
                    branch_name,
                    salon_name,
                    branch_id,
                } = resData.data;

                Cookies.set("loggedIn", "true", {
                    expires: rememberMe ? 10 : null,
                });
                Cookies.set("type", type, { expires: rememberMe ? 10 : null });
                Cookies.set("salonName", salon_name, {
                    expires: rememberMe ? 10 : null,
                });
                Cookies.set("branch_n", branch_name, {
                    expires: rememberMe ? 10 : null,
                });

                localStorage.setItem("token", token);
                localStorage.setItem("type", type);
                localStorage.setItem("branch_id", branch_id);
                localStorage.setItem("number", btoa(user));
                localStorage.setItem("branch_name", btoa(branch_name));
                localStorage.setItem("s-name", salon_name);
                localStorage.setItem("user", JSON.stringify(resData.data));

                toast.success("Login successful! Redirecting...", {
                    autoClose: 2000,
                });

                setTimeout(() => {
                    navigate(
                        `/staff/${salon_name}/${btoa(
                            branch_name
                        )}/staffdashboard`
                    );
                }, 2200);
            } else {
                toast.error("Invalid credentials. Please try again.");
            }
        } catch (err) {
            console.error("Login error:", err);
            toast.error("Something went wrong. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-8 font-sans"
            style={{ zoom: 1.33 }}
        >
            <ToastContainer position="top-center" />

            <div className="w-full max-w-md">
                <div className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden animate-fade-in">
                    <div className="px-6 py-4 text-center">
                        <img
                            src="/header_crm_logo.webp"
                            alt="CRM Logo"
                            className="h-36 w-auto mx-auto"
                            onClick={() => navigate("/")}
                        />
                        <h1 className="text-xl font-semibold text-gray-800 mt-2">
                            Welcome Back!
                        </h1>
                    </div>

                    <form onSubmit={handleStaffLogin} className="p-6">
                        <div className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Phone Number
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <FaMobileAlt className="h-4 w-4 text-gray-400" />
                                    </div>
                                    <input
                                        type="tel"
                                        placeholder="Enter your phone number"
                                        className="w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-blue-600 transition"
                                        value={mobileno}
                                        onChange={(e) =>
                                            setMobileno(e.target.value)
                                        }
                                        required
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Password
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <FaLock className="h-4 w-4 text-gray-400" />
                                    </div>
                                    <input
                                        type={
                                            showPassword ? "text" : "password"
                                        }
                                        placeholder="Enter your password"
                                        className="w-full pl-10 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-blue-600 transition"
                                        value={password}
                                        onChange={(e) =>
                                            setPassword(e.target.value)
                                        }
                                        required
                                    />
                                    <button
                                        type="button"
                                        className="absolute inset-y-0 right-0 pr-3 flex items-center"
                                        onClick={() =>
                                            setShowPassword(!showPassword)
                                        }
                                    >
                                        {showPassword ? (
                                            <FaEyeSlash className="h-4 w-4 text-gray-400 hover:text-gray-600" />
                                        ) : (
                                            <FaEye className="h-4 w-4 text-gray-400 hover:text-gray-600" />
                                        )}
                                    </button>
                                </div>
                            </div>

                            {/* <div className="flex items-center">
                                <label className="inline-flex items-center text-sm text-gray-600">
                                    <input
                                        type="checkbox"
                                        className="mr-2 h-4 w-4 text-blue-600 border-gray-300 rounded"
                                        checked={rememberMe}
                                        onChange={(e) =>
                                            setRememberMe(e.target.checked)
                                        }
                                    />
                                    Remember me
                                </label>
                            </div> */}

                            <button
                                type="submit"
                                disabled={loading}
                                className="w-full py-2.5 px-4 bg-blue-600 hover:bg-blue-800 disabled:bg-blue-400 text-white font-medium rounded-lg transition flex items-center justify-center gap-2"
                            >
                                {loading ? (
                                    <>
                                        <FiLoader className="animate-spin h-4 w-4" />
                                        Signing in...
                                    </>
                                ) : (
                                    "Sign In"
                                )}
                            </button>
                        </div>
                    </form>

                    <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
                        <p className="text-center text-xs text-gray-500">
                            Need assistance? Contact your system administrator
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default StaffLogin;
